import React from 'react';
import './Features.scss';
import SectionTitleUp from '../../components/SectionTitle/SectionTitleUp';
import IconList from '../../components/IconList/IconList';
import featuresData from './FeaturesData';

const Features = () => {
    return (
        <section className='section-bgnew section-common features-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitleUp subTitle="OFFICE" title="Top notch dentistry in South Colombo" description="Our dental studio is different from it's quality, comfort and technology."/>

                <div className="row align-items-center">
                    {
                        featuresData.map(singleFeature => 
                            <IconList 
                                icon={singleFeature.icon} 
                                title={singleFeature.title}
                                description={singleFeature.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Features;